import { render, staticRenderFns } from "./returnQuery.vue?vue&type=template&id=1adf69b0&scoped=true"
import script from "./returnQuery.vue?vue&type=script&lang=js"
export * from "./returnQuery.vue?vue&type=script&lang=js"
import style0 from "./returnQuery.vue?vue&type=style&index=0&id=1adf69b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adf69b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1adf69b0')) {
      api.createRecord('1adf69b0', component.options)
    } else {
      api.reload('1adf69b0', component.options)
    }
    module.hot.accept("./returnQuery.vue?vue&type=template&id=1adf69b0&scoped=true", function () {
      api.rerender('1adf69b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/returnCenter/returnQuery.vue"
export default component.exports